import { TypeReturn } from '@components/styled-autocomplete/useStyledAutocomplete';
import { ListProps, Paging } from '@Core';
import { IGetCameraProps } from '@EcamModel/controllers/ICameraHttpController';
import { IGetLocationProps } from '@EcamModel/controllers/ILocationHttpController';
import { IGetZoneProps } from '@EcamModel/controllers/IZoneHttpController';
import { Camera, CameraWithInfo, ContraventionReasonTranslations, Location } from '@EcamModel/model';
import { PermitExempt, ScopeType } from '@EcamModel/model/PermitExempt';
import { VehicleExempt } from '@EcamModel/model/VehicleExempt';
import { Zones } from '@EcamModel/model/Zones';
import { UsePopUpReturnType } from '@hooks/usePopUp';
import { BaseSelect } from '@pages/cameras/list';
import { PropsFilterChild } from '@pages/task-management/components/FilterChildForTaskManagement';
import { MutableRefObject } from 'react';
import { IPopUp } from '@hooks/usePopUp';

type FilterExemptState = {
    page: number;
    location?: Location;
    camera?: CameraWithInfo;
    zone?: Zones;
    searchValue?: string;
    searchType?: BaseSelect;
    contraventionReasonTranslations?: ContraventionReasonTranslations;
};

type PropsPopUpUpsertPermit = IPopUp & {
    itemVRNsPlate?: any;
    listLocationsAutocomplete: TypeReturn<Location, IGetLocationProps>;
    listZonesAutocomplete: TypeReturn<Zones, IGetZoneProps>;
    listCamerasAutocomplete: TypeReturn<CameraWithInfo, IGetCameraProps>;
    onSetItemVRNsPlate: (item?: VehicleExempt) => void;
};

type FormValuesUpsertPermit = {
    scopePermit: ScopeType;
    location?: any;
    zone?: Zones;
    camera?: Camera;
    plates: VehicleExempt[];
    note?: string;
};

interface PropsFilter extends Partial<PropsFilterChild> {
    filterState: Partial<FilterExemptState>;
    onchangeSearchPlate: _.DebouncedFunc<(value: string) => void>;
    searchRef: MutableRefObject<HTMLInputElement | null>;
    listLocationAutocomplete: TypeReturn<Location, IGetLocationProps>;
    listZonesAutocomplete: TypeReturn<Zones, IGetZoneProps>;
    listCameraAutocomplete: TypeReturn<CameraWithInfo, IGetCameraProps>;
    listContraventionAutocomplete: TypeReturn<ContraventionReasonTranslations, ListProps<ContraventionReasonTranslations>>;
    onSetPartialFilter: (filter: Partial<FilterExemptState>) => void;
}

interface PropsListData {
    listExemptPermits: Paging<VehicleExempt>;
    isLoading: boolean;
    popUpConfirmDelete: UsePopUpReturnType;
    onSetItemVRNsPlate: (item?: VehicleExempt) => void;
    onChangePage: (page: number) => void;
    searchValue?: string;
}

const searchTypes: BaseSelect[] = [
    {
        Id: -1,
        Name: 'Search by',
        Value: undefined,
    },
    {
        Id: 1,
        Name: 'Location',
        Value: ScopeType.Location,
    },
    {
        Id: 2,
        Name: 'Zone',
        Value: ScopeType.Zone,
    },
    {
        Id: 3,
        Name: 'Camera',
        Value: ScopeType.Camera,
    },
];

const mappingScopePermit: Record<ScopeType, string> = {
    [ScopeType.Global]: 'Global',
    [ScopeType.Location]: 'Location',
    [ScopeType.Zone]: 'Zone',
    [ScopeType.Camera]: 'Camera',
    [ScopeType.GeoZone]: 'Geo-zone',
};

export {
    type FilterExemptState,
    type PropsFilter,
    type PropsListData,
    type FormValuesUpsertPermit,
    type PropsPopUpUpsertPermit,
    searchTypes,
    mappingScopePermit,
};
